export function setBodyClass(className: string) {
    document.body.classList.add(className);
}

export function unsetBodyClass(className: string) {
    document.body.classList.remove(className);
}
